import useSWR from "swr";
import { GroupItemsResult } from "@/types";
import { getGroupItems } from "@/services/storageManager";

/**
 * Supervisor group view: everything uploaded/shared by members of the Entra
 * groups the supervisor belongs to.
 */
export function useGroupItems(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR<GroupItemsResult>(
    enabled ? "/access/group-items" : null,
    getGroupItems,
    { revalidateOnFocus: false }
  );

  return {
    items: data?.items || [],
    groups: data?.groups || [],
    members: data?.members || [],
    memberCount: data?.memberCount || 0,
    isLoading,
    isError: error,
    mutate,
  };
}
